import { createBlocksModel } from '@wix/yoshi-flow-editor/blocks';

export default createBlocksModel({
  widgetName: 'Post Divider',
  props: {},
  methods: {},
  events: {},
});
